export default __webpack_public_path__ + "static/media/401.2ddec86b.gif";